// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-container ion-button {
  --border-radius: 0;
  --padding-start: 0;
  --padding-end: 0;
  width: auto;
  min-width: 190px;
  height: 46px;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.375rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  align-items: center;
  --background: var(--ion-app-primary);
  --border-radius: 0;
  --box-shadow: none;
}
.btn-container ion-button .text-css {
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.375rem;
  padding: 0 0.8125rem;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.4px;
}
.btn-container ion-button ion-icon {
  margin: 0 0.625rem;
  font-size: 1.125rem;
  align-items: center;
  display: flex;
}
.btn-container ion-button i {
  margin: 0 0.625rem;
  font-size: 1.25rem;
  align-items: center;
  display: flex;
}
.btn-container .notify-button {
  height: 39px;
  min-width: 136px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  margin-top: 0.75rem;
}

.hide-btn-mobile {
  display: block;
  margin-top: 1.25rem;
  margin-bottom: 0.9375rem;
}

.full-width {
  width: 100%;
}

.btn-css {
  --border-radius: 0 !important;
  --box-shadow: none !important;
}

.box-shadow-none {
  box-shadow: none !important;
  --box-shadow: none;
}
.box-shadow-none button-native {
  box-shadow: none;
}

@media screen and (max-width: 1024px) {
  .hide-btn-mobile {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/common-button/common-button.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;AADR;AAGQ;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AADZ;AAMQ;EACI,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AAJZ;AAOQ;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AALZ;AASI;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAPR;;AAWA;EACI,cAAA;EACA,mBAAA;EACA,wBAAA;AARJ;;AAWA;EACI,WAAA;AARJ;;AAWA;EACI,6BAAA;EACA,6BAAA;AARJ;;AAWA;EACI,2BAAA;EACA,kBAAA;AARJ;AAWI;EACI,gBAAA;AATR;;AAaA;EACI;IACI,wBAAA;EAVN;AACF","sourcesContent":[".btn-container {\n    ion-button {\n        --border-radius: 0;\n        --padding-start: 0;\n        --padding-end: 0;\n\n        width: auto;\n        min-width: 190px;\n        height: 46px;\n        font-weight: 700;\n        font-size: 1rem;\n        line-height: 1.375rem;\n        letter-spacing: 0.4px;\n        text-transform: uppercase;\n        align-items: center;\n        --background: var(--ion-app-primary);\n        --border-radius: 0;\n        --box-shadow: none;\n\n        .text-css {\n            font-weight: 700;\n            font-size: 1rem;\n            line-height: 1.375rem;\n            padding: 0 0.8125rem;\n            display: flex;\n            align-items: center;\n            text-align: center;\n            letter-spacing: 0.4px;\n        }\n\n\n\n        ion-icon {\n            margin: 0 0.625rem;\n            font-size: 1.125rem;\n            align-items: center;\n            display: flex;\n        }\n\n        i {\n            margin: 0 0.625rem;\n            font-size: 1.25rem;\n            align-items: center;\n            display: flex;\n        }\n    }\n\n    .notify-button {\n        height: 39px;\n        min-width: 136px;\n        font-size: 0.875rem;\n        font-weight: 500;\n        cursor: pointer;\n        margin-top: 0.75rem;\n    }\n}\n\n.hide-btn-mobile {\n    display: block;\n    margin-top: 1.25rem;\n    margin-bottom: 0.9375rem;\n}\n\n.full-width {\n    width: 100%;\n}\n\n.btn-css {\n    --border-radius: 0 !important;\n    --box-shadow: none !important;\n}\n\n.box-shadow-none {\n    box-shadow: none !important;\n    --box-shadow: none;\n\n\n    button-native {\n        box-shadow: none;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .hide-btn-mobile {\n        display: none !important;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
